// SubscriptionContext.tsx
import { createMemo, createContext, useContext, JSX, createResource } from "solid-js";
import { createAsync, query } from "@solidjs/router";
import { getByUserQuery } from "~/lib/queries";

import  { RIASRecordType, type Subscription } from "~/lib/types";


type SubscriptionContextValue = {
	allSubs: () => Subscription[];
	activeSubs: () => Subscription[];
};

export const SubscriptionContext = createContext<SubscriptionContextValue>();

export const useSubscriptions = (): SubscriptionContextValue => useContext( SubscriptionContext ) as SubscriptionContextValue;

const getSubs = query( async ( id: number | undefined = undefined ) => {
	"use server";

	const { getByUserQueryServer } = await import("~/_server/dynamoQueries");

	const r = await getByUserQueryServer( RIASRecordType.SUBSCRIPTION, -1 ).then( res => res.items.sort( ( a, b ) => a.created - b.created ) ?? [] );

	return r;
}, "getUserSubscriptions" );


export const SubscriptionsProvider = ( props: { children: JSX.Element } ) => {

	const subscriptionsRaw = createAsync( () => getSubs() );

	const allSubs = createMemo<Subscription[]>( () => subscriptionsRaw() ?? [] );

	const activeSubs = createMemo<Subscription[]>( () => allSubs()?.filter( ( sub: Subscription ) => sub.status == "active" && sub.scheme != "cpd" ) ?? [] as Subscription[] );

	return (
		<SubscriptionContext.Provider value={{ allSubs, activeSubs }}>
			{props.children}
		</SubscriptionContext.Provider>
	);
};

